<template>
  <div class="news-detail">
    <AppLoading class="mx-auto my-5" v-if="loading" />
    <div v-if="model" class="container">
      <Toolbar title-tag="h1" class="news-detail__toolbar">
        <template #title>
          {{ model.title }}
        </template>
      </Toolbar>

      <div class="news-detail__body">
        <CardMedia
          triangles
          class="news-detail__media"
          :src="model.image"
          height="350"
        >
          <CardMediaContent class="align-end">
            <div v-if="model.created_at" class="news-detail__published">
              Опубликовано: {{ model.created_at | dayjs("DD.MM.YYYY") }}
            </div>
          </CardMediaContent>
        </CardMedia>
        <ContentText class="news-detail__texts" v-html="model.content" />
      </div>
    </div>
  </div>
</template>

<script>
import { Toolbar } from "@/components/ui/toolbar/";
import service from "@/services/news";

export default {
  name: "NewsDetail",
  components: {
    Toolbar
  },

  data: () => ({
    model: null
  }),

  watch: {
    "$route.params.slug": {
      immediate: true,
      handler: "fetchNewsItem"
    }
  },

  methods: {
    async fetchNewsItem() {
      this.loading = true;
      const { data, success } = await service.getOne(this.$route.params.slug);
      if (!success || !data) {
        this.$router.push("/404");
      } else {
        this.model = data;
      }
      this.loading = false;
    }
  },

  breadcrumb() {
    const { model, $route } = this;
    return {
      title: model ? model.title : "Страница новости",
      to: {
        name: "news-detail",
        params: { slug: $route.params.slug }
      }
    };
  }
};
</script>

<style lang="scss">
.news-detail {
  &__toolbar {
    margin-bottom: 20px;

    .toolbar__title {
      flex-shrink: 1;
    }
    .toolbar__title-content {
      text-transform: initial;
    }
  }

  &__body {
    background-color: #fff;
    box-shadow: shadow(), shadow(), shadow();
  }

  &__published {
    text-shadow: 0 0 5px #000;
  }

  &__published,
  &__texts {
    padding: 40px;
  }

  @include breakpoint("sm-and-down") {
    &__published {
      padding: 30px 15px;
    }

    &__texts {
      padding: 20px 15px;
    }

    &__toolbar {
      .toolbar__title {
        padding: 15px;
      }

      .toolbar__content {
        display: none;
      }
    }
  }
}
</style>
